import CameraIcon from "@material-ui/icons/CameraAlt";
import { IRoute } from "../../common/typings/routes";
import { Camera } from "./Camera";
import { CameraStream } from "./pages/CameraStream";

export const CameraRoute: IRoute = {
  title: "Camera Stream",
  path: "/camera",
  component: Camera,
  guard: true,
  subRoutes: [
    { icon: CameraIcon, component: CameraStream, path: "/stream", title: "Camera Stream" },
  ],
};
